/**
 * Portal copy, Arabic first — the landing site's default language, and the one
 * most parents read. English is the fallback dictionary for any key an Arabic
 * translation is missing (see i18n.jsx).
 */

export const STRINGS = {
  ar: {
    common: {
      cancel: 'إلغاء',
      confirm: 'تأكيد',
      confirmTitle: 'هل أنت متأكد؟',
      invalidInput: 'قيمة غير صالحة',
      ok: 'حسنًا',
      save: 'حفظ',
      saving: 'جارٍ الحفظ…',
      edit: 'تعديل',
      delete: 'حذف',
      add: 'إضافة',
      close: 'إغلاق',
      loading: 'جارٍ التحميل…',
      retry: 'إعادة المحاولة',
      back: 'رجوع',
      none: '—',
    },
    brand: {
      name: 'رفوفي',
      portal: 'حسابي',
    },
    nav: {
      overview: 'نظرة عامة',
      kids: 'الأطفال',
      subscription: 'الاشتراك',
      account: 'الحساب',
      signOut: 'تسجيل الخروج',
      backToSite: 'العودة للموقع',
    },
    login: {
      title: 'تسجيل الدخول إلى حسابك',
      subtitle: 'أدر اشتراكك وملفات أطفالك من مكان واحد.',
      google: 'المتابعة باستخدام Google',
      or: 'أو',
      emailLabel: 'البريد الإلكتروني',
      emailPlaceholder: 'you@example.com',
      sendCode: 'أرسل لي رمزًا',
      passwordLabel: 'كلمة المرور',
      signIn: 'دخول',
      usePasswordInstead: 'الدخول بكلمة المرور بدلًا من ذلك',
      useCodeInstead: 'الدخول برمز عبر البريد بدلًا من ذلك',
      passwordHint: 'كلمة المرور تعمل فقط للحسابات التي أنشئت بالبريد وكلمة المرور داخل التطبيق. إن سجّلت عبر Google فاستخدم زر Google أو الرمز عبر البريد.',
      sending: 'جارٍ الإرسال…',
      codeTitle: 'أدخل الرمز',
      codeSent: 'أرسلنا رمزًا مكوّنًا من ٦ أرقام إلى {email}.',
      codeLabel: 'رمز التحقق',
      verify: 'دخول',
      verifying: 'جارٍ التحقق…',
      resend: 'إعادة إرسال الرمز',
      resendIn: 'يمكنك إعادة الإرسال بعد {seconds} ثانية',
      changeEmail: 'تغيير البريد الإلكتروني',
      googleUnavailable: 'تسجيل الدخول عبر Google غير مهيّأ حاليًا.',
      footerNote: 'بتسجيل الدخول فإنك توافق على شروط الخدمة وسياسة الخصوصية.',
      terms: 'شروط الخدمة',
      privacy: 'سياسة الخصوصية',
    },
    overview: {
      title: 'نظرة عامة',
      greeting: 'أهلًا {name}',
      greetingNoName: 'أهلًا بك',
      subscription: 'الاشتراك',
      coins: 'العملات',
      streak: 'أيام متتالية',
      longestStreak: 'أطول سلسلة: {days}',
      kidsCount: 'ملفات الأطفال',
      manageKids: 'إدارة الأطفال',
      viewSubscription: 'تفاصيل الاشتراك',
      emptyTitle: 'حسابك جاهز',
      emptyBody: 'حمّل تطبيق رفوفي لتبدأ رحلة القراءة — سيظهر تقدّم أطفالك هنا.',
      getApp: 'حمّل التطبيق',
    },
    subscription: {
      title: 'الاشتراك',
      active: 'اشتراك مفعّل',
      expired: 'الاشتراك منتهي',
      none: 'لا يوجد اشتراك',
      expiresOn: 'يتجدّد أو ينتهي في {date}',
      expiredOn: 'انتهى في {date}',
      daysLeft: 'متبقٍ {days} يومًا',
      noneBody: 'اشترك من داخل التطبيق للحصول على كل القصص والألعاب.',
      manageTitle: 'إدارة الاشتراك',
      manageBody:
        'تتم إدارة الاشتراكات من المتجر الذي اشتركت منه. افتح إعدادات الاشتراكات في حسابك على App Store أو Google Play للتجديد أو الإلغاء.',
      appStore: 'اشتراكات App Store',
      playStore: 'اشتراكات Google Play',
    },
    subscribe: {
      title: 'اختر خطتك',
      choose: 'اشترك الآن',
      starting: 'جارٍ التحويل…',
      currentPlan: 'خطتك الحالية',
      per_month: 'شهر',
      per_year: 'سنة',
      noPlans: 'لا توجد خطط متاحة حاليًا.',
      noneBody: 'اشترك لتفتح كل القصص والألعاب لأطفالك.',
      autoRenewNotice:
        'يتجدّد الاشتراك تلقائيًا في نهاية كل مدة بنفس السعر، وتُحفظ بطاقتك بأمان لدى مزوّد الدفع لهذا الغرض. يمكنك إلغاء التجديد في أي وقت من هذه الصفحة، وتحتفظ باشتراكك حتى نهاية المدة المدفوعة.',
      checkingPayment: 'نتحقق من عملية الدفع…',
      checkingBody: 'قد يستغرق التأكيد بضع ثوانٍ. لا تغلق الصفحة.',
      paymentConfirmed: 'تم تفعيل اشتراكك 🎉',
      paymentDeclined:
        'لم تتم عملية الدفع — رُفضت البطاقة ولم يُخصم أي مبلغ. جرّب بطاقة أخرى أو تواصل مع بنكك.',
      paymentPending:
        'لم يصلنا تأكيد الدفع بعد. إذا تم خصم المبلغ فسيُفعّل اشتراكك خلال دقائق — حدّث الصفحة لاحقًا، وإن استمرت المشكلة راسلنا على support@rofoofee.com.',
      manageWebBody: 'اشتراكك عبر الموقع. يمكنك إيقاف التجديد التلقائي من هنا.',
      manageStore_apple: 'اشتراكك تم شراؤه من App Store، وتتم إدارته من هناك.',
      manageStore_google: 'اشتراكك تم شراؤه من Google Play، وتتم إدارته من هناك.',
      cancelCta: 'إيقاف التجديد التلقائي',
      cancelTitle: 'إيقاف التجديد التلقائي',
      cancelBody: 'لن يتم تجديد اشتراكك تلقائيًا، وسيبقى مفعّلًا حتى {date}.',
      cancelConfirm: 'إيقاف التجديد',
      cancelKeep: 'الاحتفاظ بالاشتراك',
      cancelled: 'تم إيقاف التجديد التلقائي',
      alreadyCancelled: 'التجديد التلقائي متوقف. اشتراكك مفعّل حتى {date}.',
      endsOn: 'ينتهي في {date} (التجديد متوقف)',
    },
    kids: {
      title: 'ملفات الأطفال',
      subtitle: 'أضف طفلًا أو عدّل اسمه وتاريخ ميلاده وصورته.',
      add: 'إضافة طفل',
      main: 'الملف الرئيسي',
      name: 'الاسم',
      birthdate: 'تاريخ الميلاد',
      avatar: 'الصورة الرمزية',
      age: '{years} سنوات',
      empty: 'لا توجد ملفات بعد. أضف طفلك الأول.',
      newTitle: 'طفل جديد',
      editTitle: 'تعديل الملف',
      nameRequired: 'الاسم مطلوب',
      deleteConfirm: 'سيتم حذف ملف {name} وكل تقدّمه. لا يمكن التراجع عن هذا.',
      deleteConfirmLabel: 'حذف الملف',
      deleteMainBlocked: 'لا يمكن حذف الملف الرئيسي.',
      created: 'تمت إضافة الملف',
      updated: 'تم حفظ التعديلات',
      deleted: 'تم حذف الملف',
    },
    account: {
      title: 'الحساب',
      email: 'البريد الإلكتروني',
      country: 'الدولة',
      signOutTitle: 'تسجيل الخروج',
      signOutBody: 'ستحتاج إلى تسجيل الدخول مرة أخرى للوصول إلى حسابك.',
    },
    errors: {
      network_error: 'تعذّر الاتصال بالخادم. تحقّق من اتصالك بالإنترنت.',
      invalid_email: 'البريد الإلكتروني غير صالح.',
      invalid_or_expired: 'الرمز غير صحيح أو منتهي الصلاحية.',
      invalid_credentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
      too_many_requests: 'محاولات كثيرة. انتظر قليلًا ثم أعد المحاولة.',
      too_many_attempts: 'محاولات كثيرة. اطلب رمزًا جديدًا.',
      email_not_configured: 'إرسال البريد غير مهيّأ على الخادم.',
      email_send_failed: 'تعذّر إرسال البريد. حاول مرة أخرى.',
      unauthorized_google_audience: 'تسجيل الدخول عبر Google غير مهيّأ لهذا الموقع.',
      name_required: 'الاسم مطلوب.',
      invalid_avatar: 'اختر صورة رمزية.',
      cannot_delete_main_profile: 'لا يمكن حذف الملف الرئيسي.',
      not_your_profile: 'هذا الملف لا يخص حسابك.',
      profile_not_found: 'لم يعد هذا الملف موجودًا.',
      not_authenticated: 'انتهت الجلسة. سجّل الدخول مرة أخرى.',
      generic: 'حدث خطأ ما. حاول مرة أخرى.',
    },
  },

  en: {
    common: {
      cancel: 'Cancel',
      confirm: 'Confirm',
      confirmTitle: 'Are you sure?',
      invalidInput: 'Invalid value',
      ok: 'OK',
      save: 'Save',
      saving: 'Saving…',
      edit: 'Edit',
      delete: 'Delete',
      add: 'Add',
      close: 'Close',
      loading: 'Loading…',
      retry: 'Try again',
      back: 'Back',
      none: '—',
    },
    brand: {
      name: 'Rofoofee',
      portal: 'My account',
    },
    nav: {
      overview: 'Overview',
      kids: 'Kids',
      subscription: 'Subscription',
      account: 'Account',
      signOut: 'Sign out',
      backToSite: 'Back to site',
    },
    login: {
      title: 'Sign in to your account',
      subtitle: 'Manage your subscription and your kids’ profiles in one place.',
      google: 'Continue with Google',
      or: 'or',
      emailLabel: 'Email',
      emailPlaceholder: 'you@example.com',
      sendCode: 'Email me a code',
      passwordLabel: 'Password',
      signIn: 'Sign in',
      usePasswordInstead: 'Use a password instead',
      useCodeInstead: 'Email me a code instead',
      passwordHint: 'A password only works for accounts created with email and password in the app. If you signed up with Google, use the Google button or an emailed code.',
      sending: 'Sending…',
      codeTitle: 'Enter your code',
      codeSent: 'We sent a 6-digit code to {email}.',
      codeLabel: 'Verification code',
      verify: 'Sign in',
      verifying: 'Verifying…',
      resend: 'Resend code',
      resendIn: 'You can resend in {seconds}s',
      changeEmail: 'Use a different email',
      googleUnavailable: 'Google sign-in is not configured.',
      footerNote: 'By signing in you agree to our Terms of Service and Privacy Policy.',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
    },
    overview: {
      title: 'Overview',
      greeting: 'Hi {name}',
      greetingNoName: 'Welcome',
      subscription: 'Subscription',
      coins: 'Coins',
      streak: 'Day streak',
      longestStreak: 'Longest streak: {days}',
      kidsCount: 'Kid profiles',
      manageKids: 'Manage kids',
      viewSubscription: 'Subscription details',
      emptyTitle: 'Your account is ready',
      emptyBody: 'Download the Rofoofee app to start reading — your kids’ progress will show up here.',
      getApp: 'Get the app',
    },
    subscription: {
      title: 'Subscription',
      active: 'Active subscription',
      expired: 'Subscription expired',
      none: 'No subscription',
      expiresOn: 'Renews or ends on {date}',
      expiredOn: 'Ended on {date}',
      daysLeft: '{days} days left',
      noneBody: 'Subscribe from inside the app to unlock every story and game.',
      manageTitle: 'Manage your subscription',
      manageBody:
        'Subscriptions are managed by the store you bought them from. Open the subscriptions section of your App Store or Google Play account to renew or cancel.',
      appStore: 'App Store subscriptions',
      playStore: 'Google Play subscriptions',
    },
    subscribe: {
      title: 'Choose your plan',
      choose: 'Subscribe',
      starting: 'Redirecting…',
      currentPlan: 'Current plan',
      per_month: 'month',
      per_year: 'year',
      noPlans: 'No plans are available right now.',
      noneBody: 'Subscribe to unlock every story and game for your kids.',
      autoRenewNotice:
        'Your subscription renews automatically at the end of each period at the same price, and your card is stored securely with our payment provider for that purpose. You can stop the renewal any time from this page and keep access until the end of the period you paid for.',
      checkingPayment: 'Confirming your payment…',
      checkingBody: 'This can take a few seconds. Please keep this page open.',
      paymentConfirmed: 'Your subscription is active 🎉',
      paymentDeclined:
        'The payment did not go through — the card was declined and you have not been charged. Try another card or check with your bank.',
      paymentPending:
        'We haven’t had confirmation yet. If you were charged, your subscription will activate within a few minutes — refresh this page shortly, and contact support@rofoofee.com if it persists.',
      manageWebBody: 'You subscribed on the web. You can stop auto-renew here.',
      manageStore_apple: 'You subscribed through the App Store, so it is managed there.',
      manageStore_google: 'You subscribed through Google Play, so it is managed there.',
      cancelCta: 'Stop auto-renew',
      cancelTitle: 'Stop auto-renew',
      cancelBody: 'Your subscription will not renew, and stays active until {date}.',
      cancelConfirm: 'Stop renewal',
      cancelKeep: 'Keep subscription',
      cancelled: 'Auto-renew stopped',
      alreadyCancelled: 'Auto-renew is off. Your subscription is active until {date}.',
      endsOn: 'Ends {date} (renewal stopped)',
    },
    kids: {
      title: 'Kid profiles',
      subtitle: 'Add a child, or change their name, birthday and avatar.',
      add: 'Add a child',
      main: 'Main profile',
      name: 'Name',
      birthdate: 'Birthday',
      avatar: 'Avatar',
      age: '{years} years old',
      empty: 'No profiles yet. Add your first child.',
      newTitle: 'New child',
      editTitle: 'Edit profile',
      nameRequired: 'Name is required',
      deleteConfirm: '{name}’s profile and all of their progress will be deleted. This cannot be undone.',
      deleteConfirmLabel: 'Delete profile',
      deleteMainBlocked: 'The main profile cannot be deleted.',
      created: 'Profile added',
      updated: 'Changes saved',
      deleted: 'Profile deleted',
    },
    account: {
      title: 'Account',
      email: 'Email',
      country: 'Country',
      signOutTitle: 'Sign out',
      signOutBody: 'You’ll need to sign in again to reach your account.',
    },
    errors: {
      network_error: 'Could not reach the server. Check your connection.',
      invalid_email: 'That email address is not valid.',
      invalid_or_expired: 'That code is wrong or has expired.',
      invalid_credentials: 'That email or password is incorrect.',
      too_many_requests: 'Too many attempts. Wait a moment and try again.',
      too_many_attempts: 'Too many attempts. Request a new code.',
      email_not_configured: 'Email sending is not configured on the server.',
      email_send_failed: 'We could not send the email. Try again.',
      unauthorized_google_audience: 'Google sign-in is not configured for this site.',
      name_required: 'A name is required.',
      invalid_avatar: 'Pick an avatar.',
      cannot_delete_main_profile: 'The main profile cannot be deleted.',
      not_your_profile: 'That profile belongs to another account.',
      profile_not_found: 'That profile no longer exists.',
      not_authenticated: 'Your session expired. Please sign in again.',
      generic: 'Something went wrong. Please try again.',
    },
  },
};

export function interp(str, vars) {
  if (!vars) return str;
  return String(str).replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? vars[k] : `{${k}}`));
}
